import Vue from 'vue'

/**
 * 获取帖子详情
 * @param {string} id [帖子ID]
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchPostDetail(id) {
  return Vue.http.get('~community/v5/tweet/{id}', { params: { id } })
}

/**
 * 话题模糊查询
 * @param {string} params.name 话题名称
 * @param {string} params.limit 限制返回数量
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchQueryTopics(params) {
  return Vue.http.get('~community/v6/tinytopics', { params })
}

/**
 * 获取话题详情
 * @param {string} id - [话题ID]
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchTopicDetail(id) {
  return Vue.http.get('~community/v6/topic/{id}', { params: { id } })
}

/**
 * 获取消息列表
 * @param {number} data.columnId - 消息栏
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchMessageListByColumnId(data, options) {
  return Vue.http
    .post('~newCommunity/v7/message/list', data, options)
    .then(res => {
      if (+res.data.status === 200) return res.data.data
      throw res.data
    })
}

/**
 * 获取用户未读消息数
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchMessageUnreadCount() {
  return Vue.http
    .post('~newCommunity/v7/message/unread/count', null, { emulateJSON: false })
    .then(res => {
      if (+res.data.status === 200) {
        return (res.data.data.columnList || []).reduce((acc, col) => {
          acc[col.columnId] = col.unreadSize
          return acc
        }, {})
      }
      throw res.data
    })
}

/**
 * 将消息标记已读
 * @param  {number} columnId - 栏目 id
 */
export function markMessageRead(columnId) {
  return Vue.http
    .post('~newCommunity/v7/message/read', { columnId })
    .then(res => {
      if (+res.data.status === 200) return res.data
      throw res.data
    })
}
